module.exports = __webpack_public_path__ + "img/img08e.dcc0dde3.png";